import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=dbba2414"
import script from "./msg.vue?vue&type=script&lang=js"
export * from "./msg.vue?vue&type=script&lang=js"
import style0 from "./msg.vue?vue&type=style&index=0&id=dbba2414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports